import { makeStyles } from '@material-ui/core';
import { themeWithoutDir as theme } from '~/modules/App/withRootTheme';

const useStyles = makeStyles({
  variationContainer: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(-1)
  },
  variationText: {
    fontSize: theme.spacing(1.25)
  },
  variationPill: {
    display: 'flex',
    marginLeft: theme.spacing(1),
    padding: theme.spacing(0.25, 0.75, 0),
    borderRadius: theme.spacing(0.5) - 1
  },
  OVER: {
    color: theme.palette.error.dark,
    backgroundColor: theme.palette.error.light,
    fill: theme.palette.error.dark
  },
  UNDER: {
    color: theme.palette.success.dark,
    backgroundColor: theme.palette.success.light,
    fill: theme.palette.success.dark
  },
  MISSING_ESTIMATE: {
    color: '#656565',
    backgroundColor: '#ebebeb',
    fill: theme.palette.taskRollUp.missing.main
  },
  MATCHING: {
    color: '#656565',
    backgroundColor: theme.palette.grey[300],
    fill: theme.palette.success.main
  },
  variationValue: {
    fontSize: theme.spacing(2) - 1,
    fontWeight: 600
  },
  variationLabel: {
    fontSize: theme.spacing(1.5),
    whiteSpace: 'pre'
  },
  variationIcon: {
    fontSize: theme.spacing(2.5),
    marginRight: theme.spacing(1),
    '&$OVER': {
      marginRight: theme.spacing(0.25)
    },
    '&$UNDER': {
      marginRight: theme.spacing(0.25)
    }
  }
});

export default useStyles;
